let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dbXh5")).then(() => parcelRequire('63ni3'));